import { devtools } from 'zustand/middleware';
import { create } from 'store/create';
import { AllocationValuesStore } from './types';

const useAllocationValuesStore = create<AllocationValuesStore>()(
  devtools(
    set => ({
      currentAllocationStatus: null,
      currentAllocationVersion: null,
      currentAllocationId: null,
      setCurrentAllocationStatus: currentAllocationStatus => set(() => ({ currentAllocationStatus })),
      setCurrentAllocationVersion: currentAllocationVersion => set(() => ({ currentAllocationVersion })),
      setCurrentAllocationId: currentAllocationId => set(() => ({ currentAllocationId })),
    }),
    {
      name: 'AllocationValuesStore',
    }
  )
);

export default useAllocationValuesStore;
